<div class="w-100-p relative">
    <mat-table #table [dataSource]="dataSource" matSort>
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selectedParticipantIds.length && isAllSelected()"
                    [indeterminate]="selectedParticipantIds.length && !isAllSelected()"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let participant">
                <mat-checkbox
                    [(ngModel)]="checkboxes[participant.id]"
                    (ngModelChange)="onSelectedChange(participant.id)"
                    (click)="$event.stopPropagation()"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                >
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell class="pr-12" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="user-details-card-container pr-12" *matCellDef="let participant">
                <div class="relative" #avatarCell>
                    <img class="avatar" *ngIf="participant.user.avatar.src; else initials" [alt]="participant.user.fullName" [src]="participant.user.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ participant.user.fullName | initials }}</div>
                    </ng-template>
                    <ng-template [onlineStateIndicator]="participant.user.isOnline"> </ng-template>
                </div>
                <app-user-details-card
                    [class.hidden]="isUserDetailsCardHidden"
                    [user]="participant.user"
                    [target]="avatarCell"
                    openedFrom="contact_card_participants_mgr"
                    (goToAction)="goToModuleParticipantPage(participant.user.id)"
                ></app-user-details-card>
            </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <mat-header-cell class="pr-12" *matHeaderCellDef mat-sort-header
                ><span class="text-left text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</span>
            </mat-header-cell>
            <mat-cell class="pr-12" *matCellDef="let participant">
                <p class="text-truncate font-semibold pointer" [tooltipIfTruncated]="participant.user.firstName">
                    {{ participant.user.firstName }}
                </p>
            </mat-cell>
        </ng-container>

        <!--Last Name Column -->
        <ng-container matColumnDef="lastName">
            <mat-header-cell class="pr-12" *matHeaderCellDef mat-sort-header>
                <span class="text-left text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}</span>
            </mat-header-cell>
            <mat-cell class="pr-12" *matCellDef="let participant">
                <p class="text-truncate font-semibold pointer" [tooltipIfTruncated]="participant.user.lastName">
                    {{ participant.user.lastName }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide="true" fxShow.gt-sm="true" class="pl-16">
                <span class="text-left text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.EMAIL' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let participant" fxHide="true" fxShow.gt-sm="true" class="pl-16">
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="bg-gray-100 hover:bg-gray-200 py-8 pr-16 pl-8 rounded-full text-truncate"
                    (click)="$event.stopPropagation()"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                >
                    <mat-icon svgIcon="send_message" class="mr-8 icon-18"></mat-icon>
                    <a class="text-truncate" [href]="'mailto:' + participant.user.email" target="_top" [tooltipIfTruncated]="participant.user.email">{{ participant.user.email }}</a>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Executions Column -->
        <ng-container matColumnDef="execution">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="pl-16">
                <span class="text-left text-sm leading-5 font-medium text-gray-600">
                    {{ (courseOffering.courseTemplate.kind === moduleKind.Template ? 'COURSES.LABEL.COURSES_EXECUTIONS' : 'MODULE.KIND.PROGRAM_EXECUTION.PLURAL') | translate }}
                </span>
            </mat-header-cell>

            <mat-cell *matCellDef="let participant" class="pl-16">
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="execution-bonbon bg-gray-100 hover:bg-gray-200 py-8 pr-12 pl-8 rounded-full max-w-full min-w-0"
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                    (click)="goToModule(participant.module); $event.stopPropagation()"
                >
                    <div *ngIf="participant.module.image; else noExecutionImage">
                        <img class="avatar pointer shrink-0" [alt]="participant.module.name" [src]="participant.module.image?.thumbUrl" />
                    </div>
                    <ng-template #noExecutionImage>
                        <div class="avatar pointer module-icon-container no-image shrink-0">
                            <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                        </div>
                    </ng-template>
                    <div fxLayout="row" fxLayoutAlign="start center" class="min-w-0 mr-8">
                        <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="participant.module | getModuleIcon"></mat-icon>
                        <span fxLayout="column" fxLayoutAlign="start" class="min-w-0">
                            <span class="text-truncate mt-0 font-medium pointer block w-100-p" [tooltipIfTruncated]="participant.module.name">{{ participant.module.name }}</span>
                            <span class="text-truncate text-xs text-gray-500">
                                {{
                                    participant.module.version
                                        ? participant.module.version
                                        : participant.module.startDate
                                        ? (participant.module.startDate | date: 'shortDate') + ' - ' + (participant.module.endDate | date: 'shortDate')
                                        : '-'
                                }}
                            </span>
                        </span>
                    </div>
                    <mat-icon class="text-gray-400 shrink-0">keyboard_arrow_right</mat-icon>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Course Completion Column -->
        <ng-container matColumnDef="completion">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="pl-16">
                <span class="text-left text-sm leading-5 font-medium text-gray-600">
                    {{ (courseOffering.courseTemplate.kind === moduleKind.Template ? 'GENERAL.PROPERTY.STATUS' : 'PROGRAMS.PROGRAM_COMPLETION') | translate }}
                </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let participant" class="pl-16">
                <span
                    class="text-truncate"
                    [tooltipIfTruncated]="participant?.moduleUserProgress?.status | getStatus: moduleCompletitionStatus:'translationLabel' | translate"
                >{{ participant?.moduleUserProgress?.status | getStatus: moduleCompletitionStatus:'translationLabel' | translate }}</span>
            </mat-cell>
        </ng-container>

        <!-- Given Certficate Column -->
        <ng-container matColumnDef="certificate">
            <mat-header-cell *matHeaderCellDef fxHide="true" fxShow.gt-sm="true">
                <span class="text-left text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.GIVEN_CERTIFICATE' | translate }}</span>
            </mat-header-cell>
            <mat-cell fxLayout="column" fxLayoutAlign="center" *matCellDef="let participant" fxHide="true" fxShow.gt-sm="true">
                <div
                    (mouseenter)="onMouseEnter($event)"
                    (mouseleave)="onMouseLeave($event)"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    *ngFor="let certificate of participant.certificates; last as isLast"
                    class="mb-4"
                    [class.mb-0]="isLast"
                >
                    <app-certificate
                        class="max-w-full"
                        [class.mb-0]="isLast"
                        [label]="certificate.name"
                        [isDownloadIconVisible]="certificate.filename ? true : false"
                        (onClick)="downloadCertificate(certificate); $event.stopPropagation()"
                    ></app-certificate>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Extended Attributes Columns -->
        <ng-container *ngFor="let attribute of extendedAttributes" [matColumnDef]="attribute.name">
            <mat-header-cell *matHeaderCellDef fxHide="true" fxShow.gt-xs="true" class="pl-16">
                <span class="text-left text-sm leading-5 font-medium text-gray-600">{{ attribute.translationKey | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let participant" fxHide="true" fxShow.gt-xs="true" class="pl-16">
                <p
                    #el
                    class="text-truncate pr-4"
                    [matTooltip]="attribute | getUserExtendedAttributeValue: participant.user.attributes"
                    [matTooltipDisabled]="el.scrollWidth <= el.clientWidth"
                    [matTooltipShowDelay]="500"
                >
                    {{ attribute | getUserExtendedAttributeValue: participant.user.attributes }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef>
                <div fxFlex="row" fxLayoutAlign="end center" class="w-100-p">
                    <mat-form-field class="active-user-columns-trigger">
                        <mat-icon matPrefix svgIcon="table_columns_dropdown"></mat-icon>
                        <mat-select
                            #columnsSelect
                            [formControl]="tableColumnsDropdown"
                            multiple
                            panelClass="active-user-columns-panel"
                            (openedChange)="onColumnsDropdownOpenedChange($event)"
                        >
                            <div class="columns-options-scroll">
                                <mat-option *ngFor="let column of possibleTableColumns" [value]="column.id" [class.hidden-option]="!column.translation">
                                    {{ column.translation | translate }}
                                </mat-option>
                            </div>
                            <footer class="apply-columns-footer" (click)="$event.stopPropagation()">
                                <button mat-flat-button color="primary" class="w-100-p" (click)="applyColumns()">
                                    {{ 'GENERAL.BUTTON.APPLY' | translate }}
                                </button>
                            </footer>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let participant">
                <div fxFlex="row" fxLayoutAlign="end center" *ngIf="showEditOptions">
                    <div
                        fxFlex="row"
                        fxLayoutAlign="end center"
                        class="opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                        [class.group-hover:!opacity-0]="isActionBoxHovered"
                    >
                        <p class="text-sm font-normal text-gray-500 mr-8">
                            {{ 'GENERAL.LABEL.SEE_PROGRESS' | translate }}
                        </p>

                        <mat-icon class="icon-18 opacity-0 transition-opacity duration-300 group-hover:opacity-100" [class.group-hover:!opacity-0]="isActionBoxHovered">
                            keyboard_arrow_right
                        </mat-icon>
                    </div>

                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        aria-label="More"
                        (click)="$event.stopPropagation()"
                        (mouseenter)="onMouseEnter($event)"
                        (mouseleave)="onMouseLeave($event)"
                    >
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <app-menu-item-button
                            [svgIcon]="'send'"
                            [label]="'GENERAL.BUTTON.NOTIFY'"
                            (onClick)="openNotifyDialog(participant.user.id)"
                            [showThreeDots]="true"
                        ></app-menu-item-button>

                        <app-menu-item-button
                            *ngIf="isCourseCatalogFeatureEnabled && participant.module?.listingId"
                            [icon]="'group'"
                            [label]="'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.OPEN_LISTING_BOOKINGS'"
                            [endIcon]="'keyboard_arrow_right'"
                            (onClick)="openListingBookings(participant)"
                        ></app-menu-item-button>

                        <app-menu-item-button
                            *ngIf="shouldRemoveBookingViaListing(participant)"
                            [icon]="'delete'"
                            [label]="'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.REMOVE_BOOKING_VIA_LISTING'"
                            [endIcon]="'keyboard_arrow_right'"
                            (onClick)="removeBookingViaListing(participant)"
                        ></app-menu-item-button>

                        <app-menu-item-button
                            *ngIf="shouldRemoveFromExecution(participant)"
                            [icon]="'delete'"
                            [label]="'PAGE.DIALOG.EDIT_RELEVANT_EXECUTIONS.LABEL.REMOVE_FROM_EXECUTION'"
                            (onClick)="unbookParticipant(participant)"
                        ></app-menu-item-button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
            *matRowDef="let participant; columns: displayedColumns"
            matRipple
            class="relative group pointer participant-row hover:bg-gray-50"
            (click)="goToModuleParticipantPage(participant.user.id, participant.module)"
        >
        </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="course-offering-participants.list" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
</div>
